<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
    <path fill="#000" d="M598.624 457.376l-192-192c-12.512-12.512-32.768-12.512-45.248 0l-192 192c-12.512 12.512-12.512 32.768 0 45.248s32.768 12.512 45.248 0l169.376-169.376 169.376 169.376c12.512 12.512 32.768 12.512 45.248 0s12.512-32.768 0-45.248z"></path>
  </svg>
</template>
